<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">
      <a [routerLink]="'/configuration/products'">Brands</a>
    </li>
    <li class="breadcrumb-item" aria-current="page">
      @if (isCreate()) {
        <span class="fs-5 fw-bold mb-0">Add product</span>
      }
      @if (!isCreate()) {
        <span class="fs-5 fw-bold mb-0">Edit product</span>
      }
    </li>
  </ol>
</nav>

@if (loaded) {
  <div class="card border-0 shadow mb-3 fade-in-zoom">
    <div class="card-body">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="row g-3 mb-3">
          <div class="col-6">
            <label for="productName" class="form-label">Name</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-tag"></i></span>
              <input type="text" class="form-control" id="productName" placeholder="Enter product name"
                formControlName="name">
            </div>
          </div>
          <div class="col-6">
            <label for="ownerCompany" class="form-label">Advertiser</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-building"></i></span>
              <select id="ownerCompany" class="form-select" formControlName="advertiserId">
                <option [ngValue]="null" disabled>Select advertiser</option>
                @for (advertiser of advertisers; track advertiser) {
                  <option [ngValue]="advertiser.id">{{ advertiser }}</option>
                }
              </select>
            </div>
          </div>
        </div>
        <div class="row g-3 mb-3">
          <div class="col-6">
            <label for="domainName" class="form-label">Domain Name</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-globe"></i></span>
              <input type="text" class="form-control" id="domainName" placeholder="Enter domain name"
                formControlName="domain">
            </div>
          </div>
          <div class="col-6">
            <label for="productType" class="form-label">Type</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-box-seam"></i></span>
              <select id="productType" class="form-select" formControlName="type">
                <option value="" disabled>Select type</option>
                <option value="two-step">Two-Step Strategy</option>
                <option value="ecommerce">E-Commerce</option>
                <option value="performance">Performance-Driven</option>
                <option value="mobile">Mobile Application</option>
                <option value="chat">Single / Multi-Chat</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row g-3 mb-3">
          <div class="col-6">
            <label for="identifier" class="form-label">API Identifier</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-tag"></i></span>
              <input type="text" class="form-control" id="identifier" placeholder="API Identifier"
                formControlName="identifier">
            </div>
          </div>
          <div class="col-6">
            <label class="form-label fw-bold small">Language</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-translate"></i></span>
              <app-dropdown-select [multiple]="true" formControlName="languages">
                @for (lang of languages; track lang) {
                  <app-dropdown-select-option [value]="lang.isoCode">
                    <img [ngSrc]="langService.getLanguageFlag(lang)" [alt]="lang.name" class="country-flag"
                      width="24" height="24">
                    {{ lang.name }}
                  </app-dropdown-select-option>
                }
              </app-dropdown-select>
            </div>
          </div>
        </div>
        <div class="row g-3">
          <div class="col-6">
            <div class="row">
              <div class="col-12">
                <label for="coreg" class="form-label">P2</label>
                <app-input-switch formControlName="coreg" id="coreg">P2</app-input-switch>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <label for="cross" class="form-label">XSELL</label>
                <app-input-switch formControlName="cross" id="cross">XSELL</app-input-switch>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <label class="form-label">Status</label>
                <app-input-switch formControlName="enabled" id="enabled">Enabled</app-input-switch>
              </div>
            </div>
          </div>
          <div class="col-6">
            <label class="form-label">Upload Logo</label>
            <div class="row">
              <div class="col">
                <label (drop)="onDropUpload($event)"
                  (dragover)="onDragOver($event)"
                  class="d-block upload-area border border-1 rounded p-4 text-center bg-light">
                  <i class="bi bi-cloud-arrow-up fs-1 text-primary"></i>
                  <p class="mt-3 mb-0 fw-bold">Drag and drop your logo here or click to upload</p>
                  <input type="file" id="logoUpload" class="form-control d-none" accept="image/*"
                    (change)="onClickUpload($event)">
                  <button type="button" class="btn btn-primary mt-3 fw-bold">Upload Logo</button>
                </label>
              </div>
              @if (uploadImage?.data || product?.logo) {
                <div class="col-auto">
                  <img [ngSrc]="uploadImage?.data || imageService.getImageUrl($safeNavigationMigration(product?.logo), 180, 180)" width="180"
                    height="180" alt="Brand logo"/>
                </div>
              }
            </div>
          </div>
          <div class="col-12 text-end">
            <button type="submit" class="btn btn-primary fw-bold" [disabled]="!canUpdate()">
              @if (isCreate()) {
                <span>Create</span>
              }
              @if (!isCreate()) {
                <span>Update</span>
              }
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
}
